<template>
  <section>
    <v-row class="ma-0 justify-center mosaico-galeria-wrapper">
      <div class="grid-wrapper">
        <div
          v-for="(content, index) in dadosColaboracoes"
          :key="content.colaboracao.id_colaboracao"
          class="fade-animation"
          :style="`animation-duration:${(index + 1) * 200}ms`"
          :class="
            colaboracaoContemMidia(content.colaboracao)
              ? 'grid-media-content-wrapper'
              : ''
          "
          v-on:click="(e) => selectColab(content.coluna, content.index, e)"
        >
          <CardMosaicoGaleria
            :content="content.colaboracao"
            :card-config="cardsConfig"
            :flg-exibir-uf="flgExibirUf"
            :producao="producao"
          ></CardMosaicoGaleria>
        </div>
      </div>
    </v-row>
  </section>
</template>
<script>
import CardMosaicoGaleria from "@/components/Cards/CardMosaicoGaleria.vue";
export default {
  components: {
    CardMosaicoGaleria,
  },
  data() {
    return {
      dadosColaboracoes: [],
    };
  },
  props: {
    colaboracoes: Object,
    cardsConfig: Object,
    flgExibirUf: Boolean,
    producao: Object,
  },
  created() {
    const { colunaExibicao1, colunaExibicao2, colunaExibicao3 } = this.colaboracoes;
    this.dadosColaboracoes = this.mesclaColaboracoes(
      colunaExibicao1,
      colunaExibicao2,
      colunaExibicao3
    );
  },
  methods: {
    mesclaColaboracoes(coluna1, coluna2, coluna3) {
      const colaboracoesCol1 = coluna1.map((colaboracao, index) => {
        return { coluna: 1, index, colaboracao };
      });
      const colaboracoesCol2 = coluna2.map((colaboracao, index) => {
        return { coluna: 2, index, colaboracao };
      });

      const colaboracoesCol3 = coluna3.map((colaboracao, index) => {
        return { coluna: 3, index, colaboracao };
      });

      return colaboracoesCol1.concat(colaboracoesCol2).concat(colaboracoesCol3);
    },
    colaboracaoContemMidia(content) {
      if (content.dsc_tipo_midia_colaboracao) {
        if (content.dsc_tipo_midia_colaboracao === "audio") {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
      // return content.url_midia_thumbnail || content.url_midia_colaboracao
    },
    selectColab(coluna, index, event) {
      const classes = [...event.target.classList];
      if (!classes.includes("mark-as-read-icon")) {
        this.$emit("onSelectColaboracao", { coluna, index });
      }
    },
  },
  watch: {
    colaboracoes(newValue) {
      const { colunaExibicao1, colunaExibicao2, colunaExibicao3 } = newValue;
      this.dadosColaboracoes = this.mesclaColaboracoes(
        colunaExibicao1,
        colunaExibicao2,
        colunaExibicao3
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.mosaico-galeria-wrapper {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}

.grid-wrapper {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  grid-auto-flow: dense;
  grid-auto-rows: minmax(200px, auto);

  @media (min-width: 62.5rem) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (min-width: 93rem) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 125rem) {
    grid-template-columns: repeat(4, 1fr);
  }

  @media (min-width: 156rem) {
    grid-template-columns: repeat(5, 1fr);
  }
}

.grid-media-content-wrapper {
  grid-row-end: span 2;
}

@keyframes easyIn {
  0% {
    opacity: 0;
    transform: scale(0.1);
  }

  100% {
    opacity: 0.9;
    transform: scale(1);
  }
}

.fade-animation {
  animation-name: easyIn;
}
</style>
